import BusinessIcon from "../../images/v2/business-icon.svg";
import InvestorIcon from "../../images/v2/investor-icon.svg";
import PropertyIcon from "../../images/v2/property-icon.svg";
import HomeIcon from "../../images/v2/home-icon-2.svg";
import { BASIC_MEMBER, INVESTOR_MEMBER, PROPERTY_MANAGER, REAL_ESTATE_AGENT } from "../common";

//Plan details modification for v2
export const PlanDetails = [
  {
    "planId": 4,
    planName: "Member",
    description: "Free 30 day trial, cancel anytime.  ",
    features: [
      "Unlimited want-listings",
      "Unlimited properties in your inventory",
      "10 free introductions per month",
    ],
  },
  {
    "planId": 2,
    planName: "Investor Member",
    description: "Free 30 day trial, cancel anytime.",
    features: [
      "Property management dashboard",
      "Additional buyer box criteria",
      "Unlimited want-listings",
      "Unlimited properties in your inventory",
      "10 free introductions per month",
      "Custom Investor profile and badge",
    ],
    badge: true,
    badgeText: "INVESTOR",
    isGoldBadge: true,
  },
  {
    "planId": 1,
    planName: "Pro Member",
    description: "Free 30 day trial, cancel anytime.",
    features: [
      "Buyer Listing Form",
      "Client management dashboard",
      "Pull reports for buyers and sellers",
      "Access to agent only feed",
      "Direct Mail campaigns to off-market matches",
      "Unlimited want-listings",
      "Unlimited properties in your inventory",
      "10 free introductions per month",
      "Custom agent profile and Pro badge",
      "See other Premium Agents’ contact info on want listings (coming soon)",
    ],
    badge: true,
    badgeText: "PRO",
    isGoldBadge: false,
  },
  {
    "planId": 3,
    planName: "Property Manager",
    description: "Free 30 day trial, cancel anytime.",
    features: [
      "Buyer Listing Form",
      "Client management dashboard",
      "Pull reports for buyers and sellers",
      "Access to agent only feed",
      "Direct Mail campaigns to off-market matches",
      "Unlimited want-listings",
      "Unlimited properties in your inventory",
      "10 free introductions per month",
      "Custom agent profile and Pro badge",
      "See other Premium Agents’ contact info on want listings (coming soon)",
    ],
    badge: true,
    badgeText: "PRO",
    isGoldBadge: false,
  },
];

export const USER_TYPE_MEMBER = 1;
export const USER_TYPE_AGENT = 2;
export const USER_TYPE_PROPERTY_MANAGER = 2;
export const USER_TYPE_INVESTOR = 1;

export const USER_TYPE_MAPPING = {
  1: "customer",
  2: "agent",
  3: "property_manager",
  4: "investor",
};

export const userTypes = [
  {
    icon: BusinessIcon,
    userTypeId: USER_TYPE_AGENT,
    title: REAL_ESTATE_AGENT,
    planSelection: "Pro Member",
    heading: "I'm a Real Estate Agent",
    description:
      "Your here to provide value to your clients, discover deals, find matches & grow your business.",
  },
  {
    icon: InvestorIcon,
    userTypeId: USER_TYPE_INVESTOR,
    title: INVESTOR_MEMBER,
    heading: "I'm an Investor",
    planSelection: "Investor Member",
    description:
      "Your here to find specific investment opportunities and connect with buyers/renters.",
  },
  {
    icon: PropertyIcon,
    userTypeId: USER_TYPE_PROPERTY_MANAGER,
    title: PROPERTY_MANAGER,
    heading: "I'm a Property Manager",
    planSelection: "Pro Member",
    description:
      "Your here to browse potential tenants, find opportunities in advance and help your clients.",
  },
  {
    icon: HomeIcon,
    userTypeId: USER_TYPE_MEMBER,
    title: BASIC_MEMBER,
    heading: "I'm a Buyer, Renter or Owner",
    planSelection: "Member",
    description:
      "Your here to find new properties, gauge demand for your home and discover matches.",
  },
];

export const PLAN_TYPES = [
  {
    name: "Lite",
    amount: "free",
  },
  // {
  //     name : 'Pro Member',
  //     amount : 'free'
  // },
  {
    name: "Member",
    amount: {
      monthly: 12,
      annual: 10,
    },
  },
  {
    name: "Investor Member",
    amount: {
      monthly: 15,
      annual: 12,
    },
  },
  {
    name: "Pro Member",
    amount: {
      monthly: 15,
      annual: 12,
    },
  },
  {
    name: "Property Manager",
    amount: {
      monthly: 15,
      annual: 12,
    },
  },
];
